import { Divider, Grid, IconButton, Tooltip } from '@material-ui/core';
import { SelectImovelCreatable } from 'app/components/Select';
import { excluirAlert } from 'app/services/alerts';
import imovelApi from 'app/services/api/imovelApi';
import * as Actions from 'app/store/actions';
import React, { useState } from 'react';
import { MdDelete, MdModeEdit } from 'react-icons/md';
import { useDispatch } from 'react-redux';
import ImovelModal from '../modal/ImovelModal';

const ImovelRelacionado = ({ values, handleChange, handleBlur, errors, disabled }) => {
  const dispatch = useDispatch();

  const [imovelCadastro, setImovelCadastro] = useState();

  const imovelSelecionado = values?.imovel?.id;

  const showError = (message) => {
    dispatch(Actions.showMessage({ message, variant: 'error' }));
  };

  const setImovel = (imovel) => {
    handleChange({
      target: {
        id: 'imovel',
        value: imovel ? { id: imovel.id, nome: imovel.nome } : undefined,
      },
    });
  };

  const handleCadastrar = (nome) => {
    setImovelCadastro({ nome });
  };

  const handleEditar = async () => {
    try {
      const response = await imovelApi.buscarPorId(values.imovel.id);

      setImovelCadastro(response.data);
    } catch (error) {
      showError(error?.response?.data?.message || 'Não foi possível carregar o imóvel');
    }
  };

  const handleExcluir = () => {
    excluirAlert({
      confirmar: async () => {
        try {
          await imovelApi.delete({ ids: [values.imovel.id], tipoSelecao: 'NENHUM', query: '' });

          setImovel(undefined);

          dispatch(Actions.showMessage({ message: 'Imóvel excluído com sucesso', variant: 'success' }));
        } catch (error) {
          showError(error?.response?.data?.message || 'Não foi possível excluir o imóvel');
        }
      },
    });
  };

  return (
    <>
      <Grid item xs={12}>
        <Divider style={{ backgroundColor: 'rgba(0, 0, 0, 0.50)' }} />
      </Grid>

      <Grid item xs={12}>
        <span
          style={{
            fontSize: '15px',
            color: 'black',
            marginRight: '5px',
            fontWeight: '500',
          }}
        >
          Imóvel relacionado
        </span>

        <p style={{ marginTop: 4 }}>
          Selecione o imóvel administrado relacionado a este contrato. As informações do imóvel serão utilizadas na
          emissão da NFS-e.
        </p>
      </Grid>

      <Grid item xs={12} sm={12} md={7} lg={7} xl={7}>
        <SelectImovelCreatable
          id="imovel"
          idObject="imovel"
          label="Imóvel"
          imovel={values?.imovel}
          handleChange={handleChange}
          handleBlur={handleBlur}
          onCadastrarImovel={handleCadastrar}
          required
          error={errors?.imovel}
          touched={!!errors?.imovel}
          disabled={disabled}
        />
      </Grid>

      {imovelSelecionado && !disabled && (
        <Grid item xs={1} style={{ display: 'flex' }}>
          <Tooltip title="Editar imóvel" placement="right-end">
            <Grid item style={{ justifyContent: 'center', alignContent: 'center' }}>
              <IconButton size="small" onClick={handleEditar}>
                <MdModeEdit size={18} />
              </IconButton>
            </Grid>
          </Tooltip>

          <Tooltip title="Excluir imóvel" placement="right-end">
            <Grid item style={{ justifyContent: 'center', alignContent: 'center' }}>
              <IconButton size="small" onClick={handleExcluir}>
                <MdDelete size={18} />
              </IconButton>
            </Grid>
          </Tooltip>
        </Grid>
      )}

      <ImovelModal
        open={!!imovelCadastro}
        imovel={imovelCadastro}
        onSalvar={(imovelSalvo) => {
          setImovel(imovelSalvo);
          setImovelCadastro(undefined);
        }}
        onFechar={() => setImovelCadastro(undefined)}
      />
    </>
  );
};

export default ImovelRelacionado;
